<template>
    <div class="bodys Tda">
        <main>
            <!-- section-TDA首屏 -->
            <section class="section-hero">
                <div class="hero">
                    <div class="tda-description-box">
                        <div class="tda-text-box">
                            <h1 class="heading-primary heading-primary-child">
                                诊断性测试(TDA)
                                <div class="heading-fifth">Targeted Diagnostic Assessment</div>
                            </h1>
                            <p class="tda-description">
                                为贯彻全国教育大会精神，积极响应《国务院关于深化考试招生制度改革的实施意见》《深化新时代教育评价改革总体方案》《教育部关于加强和改进普通高中学生综合素质评价的意见》等文件要求，CSSAT设置诊断性测试(TDA)评价序列。
                            </p>
                            <p class="tda-description">
                                <strong>诊断性测试(TDA，Targeted Diagnostic Assessment)</strong
                                >是以中国高考评价体系、普通高中课程方案和各个学科课程标准为依据，结合大学考查视角对学生提供对接新高考模式的诊断性评价，旨在通过科学的、客观的过程性评价，促进中学生学科素养提升，助力大中衔接。
                            </p>
                            <p class="tda-description">
                                根据2017-2024年历次诊断性测试数据的分析结果显示，考生成绩与排名具有良好的区分度与高考成绩及高中学业水平之间存在良好的一致性。
                            </p>
                        </div>
                        <div class="tda-schedule-box">
                            <p class="tda-schedule-title">
                                <i class="ph ph-calendar-check schedule-icon"></i>
                                <span>考试时间安排</span>
                            </p>
                            <div class="tda-date-boxes">
                                <div class="date-box">
                                    <p class="test-date"><span>2025年9月18日-9月19日</span></p>
                                    <p class="test-name">TDA-G11</p>
                                </div>
                                <div class="date-box">
                                    <p class="test-date"><span>2025年10月30日-11月1日</span></p>
                                    <p class="test-name">TDA-G12: 10月30日-31日</p>
                                    <p class="test-name">强基诊断(居家考): 11月1号</p>
                                </div>
                                <div class="date-box">
                                    <p class="test-date"><span>2025年12月7日</span></p>
                                    <p class="test-name">TDA-G10</p>
                                </div>
                                <div class="date-box">
                                    <p class="test-date"><span>2025年12中旬</span></p>
                                    <p class="test-name">TDA-G12</p>
                                </div>
                                <div class="date-box">
                                    <p class="test-date"><span>2026年3月下旬或4月上旬</span></p>
                                    <p class="test-name">TDA-G10，TDA-G12</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="hero-bottom">
                        <div class="hero-buttons">
                            <a href="https://student.cssat.cn" class="btn btn--full"
                            >个人报名 &rarr;</a>
                            <a href="https://school.cssat.cn" class="btn btn--full"
                            >已有中学账号，去报名 →</a>
                            <a href="#register-subsection" class="btn btn--full"
                            >无中学账号，去申请 →</a>
                        </div>
                        <p class="bottom-tips">
                            <span class="color_red">*</span> 注意：个人报名仅支持 TDA-G10 和 TDA-G12(强基诊断-居家考)。对于中学报名，先前未参试中学需先通过考试项目组申请系统账号。
                        </p>
                    </div>
                </div>
            </section>

            <!-- section-考试类别 -->
            <section class="section-grade-type section tab-area-container" style="padding-bottom: 0;">
                <div class="container">
                    <h2 class="heading-secondary heading-secondary--features">
                        <p class="section-title">
                            <span class="section-title-text">诊断性测试(TDA)类别</span>
                        </p>
                    </h2>
                    <div class="tab-area">
                        <div v-for="item in tabList"
                             :key="item"
                             :id="item"
                             :class="{
                                 'tab-area-item' :true,
                                 'is-active':activeTab==item,
                             }"
                             @click="changeActiveTab(item)">{{item}}
                        </div>
                    </div>
                </div>
            </section>

            <TDA-G10 v-if="activeTab=='TDA-G10'"/>
            <TDA-G11 v-if="activeTab=='TDA-G11'"/>
            <TDA-G12 v-if="activeTab=='TDA-G12'"/>
        </main>
    </div>
</template>

<script>
    import TDAG10 from "./UI/TDA-G10";
    import TDAG11 from "./UI/TDA-G11";
    import TDAG12 from "./UI/TDA-G12";

    export default {
        name: 'Tda',
        metaInfo: {
            title: "CSSAT、TDA-标准学术能力测试（诊断性测试）",
            meta: [
                {
                    name: 'description',
                    content: '诊断性测试(TDA，Targeted Diagnostic Assessment)是以中国高考评价体系、普通高中课程方案和各个学科课程标准为依据，结合大学考查视角对学生提供对接新高考模式的诊断性评价，旨在通过科学的、客观的过程性评价，促进中学生学科素养提升，助力大中衔接。'
                }
            ]
        },
        components: {TDAG10, TDAG11, TDAG12},
        data() {
            return {
                tabList: ['TDA-G10', 'TDA-G11', 'TDA-G12'],
            }
        },
        computed: {
            activeTab() {
                let that = this;
                return that.$store.getters.getActiveTab('TDA');
            },
        },
        mounted() {
            let hash = this.$route.hash;
            if (hash) {
                hash = hash.slice(1)
                this.scrollToElement(hash);
            }
        },
        methods: {
            changeActiveTab(val) {
                let that = this;
                that.$store.commit('setActiveTab', {
                    key: 'TDA',
                    tab: val
                });
            },
            scrollToElement(elementId) {
                const el = this.$el.querySelector(`#${elementId}`);
                if (el) {
                    window.scrollTo({
                        top: el.offsetTop,
                        behavior: 'smooth'
                    });
                }
            },
        },
        watch: {
            '$route'(to, from) {
                let hash = to.hash;
                if (hash) {
                    hash = hash.slice(1)
                    this.scrollToElement(hash);
                }
                console.log('路由变化了！', from.path, '->', to.path)
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../assets/css/main--tda.css';
    @import '../assets/css/queries--tda.css';
    @import '../assets/scss/main--tda.scss';
    @import '../assets/scss/queries--tda.scss';
</style>
